import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Role } from '../../model/role.model';
import { RoleService } from '../../services/role.service';
import { RoleFilter } from '../../model/role-filter.model';
import { Pageable } from '../../../shared/model/pageable';
import { finalize } from 'rxjs/operators';
import { HttpResponse } from '@angular/common/http';
import { Location } from '../../../shared/location/model/location';
import { TranslateService } from '@ngx-translate/core';
import { JhiEventManager, JhiLanguageService } from '../../../shared/core-utils';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertService } from '../../../shared/alert/alert.service';
import { SiteAdminContext } from '../../site-admin-context';
import { SubscriptionsManager } from '../../../shared/util/subscriptions-manager';

@Component({
    selector: 'jhi-roles-pane',
    templateUrl: 'roles-pane.component.html',
    styleUrls: ['roles-pane.component.css']
})

export class RolesPaneComponent implements OnInit, OnDestroy {

    itemsPerPage: any = 20;
    page: number;
    message: string;
    predicate: any;
    previousPage: number;
    reverse: boolean;
    totalItems: number;

    roles: Role[];

    ColumnLabels = ColumnLabels;

    isLoading: boolean;

    roleSearchRequest: RoleFilter;

    subscriptionsManager: SubscriptionsManager = new SubscriptionsManager();

    constructor(private roleService: RoleService,
                private router: Router,
                private activatedRoute: ActivatedRoute,
                public translateService: TranslateService,
                private jhiLanguageService: JhiLanguageService,
                private modalService: NgbModal,
                private alertService: AlertService,
                private eventManager: JhiEventManager,
                private context: SiteAdminContext) {

        this.page = 1;
        this.totalItems = 0;
        this.predicate = ColumnLabels.ROLE_NAME;
        this.reverse = true;
        this.roleSearchRequest = new RoleFilter();
    }

    ngOnDestroy(): void {
        this.subscriptionsManager.unsubscribeAll();
    }

    ngOnInit() {
        this.loadAll(this.request);
        this.registerRoleChanged();
    }

    private loadAll(request: RoleFilter) {
        this.isLoading = true;
        this.roleService.searchRoles(new RoleFilter(),
            <Pageable>({
                page: this.page - 1,
                size: this.itemsPerPage,
                sort: this.getSort()
            })
        ).pipe(finalize(() => {
            this.isLoading = false;
        })).subscribe(
            (res: HttpResponse<Role[]>) => this.onSuccess(res.body, res.headers)
        );
    }

    getPermissionsTitleFormat(permissions) {
        return permissions.map((permission) => permission.description).splice(1).join(' and ');
    }

    isSuperAdminRole(role: Role) {
        return role.name === 'SuperAdmin';
    }

    editRole(role: Role) {
        this.context.role = Object.assign({}, role);
        this.context.role.permissions = role.permissions.map((x) => Object.assign({}, x));
        this.router.navigate(['/', { outlets: { popup: 'role-edit-dialog' }, }], { queryParamsHandling: 'merge' });
    }

    addRole() {
        this.context.role = new Role();
        this.router.navigate(['/', { outlets: { popup: 'role-edit-dialog' }, }], { queryParamsHandling: 'merge' });
    }

    private onSuccess(data: any[], headers) {
        this.totalItems = headers.get('X-Total-Count');
        this.roles = data;
    }

    loadPage(page: number) {
        if (page !== this.previousPage) {
            this.previousPage = page;
            this.transition();
        }
    }

    private getSort() {
        if (!this.predicate) {
            return '';
        }
        return [this.predicate + ',' + (this.reverse ? 'asc' : 'desc')];
    }

    get request() {
        return this.roleSearchRequest;
    }

    set request(request: RoleFilter) {
        this.roleSearchRequest = request;
    }

    resetTable() {
        this.page = 1;
        this.previousPage = 1;
        this.loadAll(this.request);
    }

    trackId(item: Location) {
        return item.id;
    }

    registerRoleChanged() {
        this.subscriptionsManager.add = this.eventManager.subscribe('onRoleViewChanged', (event) => {
            this.loadAll(this.request);
        });
    }

    transition() {
        this.router.navigate(['site-admin', 'roles'], {
            queryParamsHandling: 'merge',
            queryParams: {
                page: this.page,
                size: this.itemsPerPage,
                sort: this.getSort()
            },
            relativeTo: this.activatedRoute
        });
        this.loadAll(this.request);
    }
}

export enum ColumnLabels {
    'ROLE_NAME' = 'name',
    'ROLE_DESCRIPTION' = 'description',
    'ROLE_TYPE' = 'roleType.id',
    'STATUS' = 'active',

}
